module.exports = "https://web-assets.ifttt.com/packs/media/shared/apple-touch-icon-57x57-precomposed-8f2fdf8b.png";